// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import _ from 'lodash'
import Vue from 'vue'
import App from './App'
import router from './router'
import Core from '@/until/core'
import store from '@/store'

Vue.config.productionTip = false

router.beforeEach((route, redirect, next) => {
    // 进入页面前
    store.commit('onChangeUid', route.params.Uid || 0)
    // store.commit('onChangeAppLoaderShow', '玩命加载中, 请稍候...')
    next()
})
router.afterEach((route) => {
    // 进入页面后
    store.commit('onChangeAppLoaderShow', false)
    store.commit('onChangeCurrentPage', route.name || '')
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>',
    mounted () {
        Core.onGetConfig()
        if (Core.hasToken()) {
            Core('Api/User/Detailed').then(body => {
                if (body.data && !body.data.error_code && body.data.data) {
                    this.$store.commit('onChangeStaffData', body.data.data)
                }
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js